export default [
    {
        path: '/fo/coin',
        name: '코인',
        component: () => import('@/page/coin/Coin.vue'),
        meta:{
            isHideHeader: false,
            isHideBack: false,
            headerTitle: '코인',
        }
    },
    {
        path: '/fo/coin/exchange',
        name: '물성교환',
        component: () => import('@/page/coin/Exchange.vue'),
        meta:{
            isHideHeader: false,
            isHideBack: false,
            headerTitle: '물성교환',
        }
    },
    {
        path: '/fo/coin/exchangeDetails',
        name: '물성교환 상세',
        component: () => import('@/page/coin/ExchangeDetails.vue'),
        meta:{
            isHideHeader: false,
            isHideBack: false,
        }
    },
]